import { createSlice } from "@reduxjs/toolkit";

// Helper
import { updatedDataByKey } from "pages/ChemicalProbes/reducer";

// Type
import { TreeNode } from 'pages/Thesaurus/Thesaurus';

// Lib
import { listTree, getLeafNodes } from 'lib/thesaurus';

// Interface
export interface ICategory {
	key?: string;
	cdId: number;
	name: string;
	description: string;
	compoundsCount: number;
	children: ICategory[];
}

interface IInitialState {
	categoriesMenu?: TreeNode[];
	categories?: ICategory[];
	loading: boolean;

	loadingCategoriesById: boolean;
	categoriesById: any;

	categoryDescription?: string;
	typeViewList: string,

	goTo: number;
	paged: boolean;
	currPage: number;
	pageSize?: number;

	checkboxAll: boolean;
	toggleFilter: boolean;

	nameDescription: string;
	selectedKeys: string[] | [];
	expandedKeys: string[] | [];
}

const initialState: IInitialState = {
	categories: [],
	loading: false,

	loadingCategoriesById: false,
	categoriesById: [],

	typeViewList: 'row',
	categoryDescription: '',

	goTo: 1,
	paged: true,
	currPage: 0,
	pageSize: 12,

	checkboxAll: false,
	toggleFilter: false,

	nameDescription: '',
	selectedKeys: [],
	expandedKeys: [],

	categoriesMenu: [],
};

export const pfizerSlice = createSlice({
	name: "pfizer",
	initialState,
	reducers: {
		updateExpandedKeys: (state, action) => {
			state.expandedKeys = action.payload;
		},
		updateSelectedKeys: (state, action) => {
			state.selectedKeys = action.payload;
		},

		changeNameDescription: (state, action) => {
			state.nameDescription = action.payload;
		},
		changeToggleFilter: (state) => {
			state.toggleFilter = !state.toggleFilter;
		},

		updatePricesAll: (state, action) => {
			state.categoriesById = action.payload;
		},
		changeCheckboxAll: (state) => {
			state.checkboxAll = !state.checkboxAll;

			state.categoriesById = state?.categoriesById?.map((item: any) => ({
				...item,
				selected: !item.isPOA && item.onStock ? state.checkboxAll : false
			}));
		},
		clearAllCheckbox: (state) => {
			state.checkboxAll = false;

			state.categoriesById = state.categoriesById.map((item: any) => ({
				...item,
				selected: false,
			}));
		},

		changeGoTo: (state, action) => {
			state.goTo = action.payload;
		},
		changeSize: (state, action) => {
			state.pageSize = action.payload;
		},
		changePage: (state, action) => {
			state.currPage = action.payload;
		},

		changeCurrentPriceType: (state, action) => {
			const id = action.payload.id;
			const type = action.payload.type;

			state.categoriesById = updatedDataByKey({
				id: id,
				value: type,
				key: 'currentTypePrice',
				data: state.categoriesById,
			});
		},
		changeQuantity: (state, action) => {
			const id = action.payload.id;
			const quantity = action.payload.quantity;

			state.categoriesById = updatedDataByKey({
				id: id,
				key: 'quantity',
				value: quantity,
				data: state.categoriesById,
			});
		},

		changeCheckboxItem: (state, action) => {
			const id = action.payload.id;

			state.categoriesById = updatedDataByKey({
				id: id,
				value: "",
				key: 'selected',
				data: state.categoriesById,
			});
		},
		changePriceItem: (state, action) => {
			const id = action.payload.id;
			const data = action.payload.data;

			state.categoriesById = updatedDataByKey({
				id: id,
				value: data,
				key: 'currentPrice',
				data: state.categoriesById,
			});
		},

		changeTypeViewList: (state, action) => {
			state.typeViewList = action.payload;
		},
		categoryDescription: (state, action) => {
			state.categoryDescription = action.payload;
		},

		getCategories: (state) => {
			state.loading = true;
		},
		getCategoriesError: (state) => {
			state.loading = false;
		},
		getCategoriesSuccess: (state, action) => {
			const data = action.payload;

			const treeData: TreeNode[] = listTree({
				key: 'key',
				data: data,
				targetBox: [],
				inputValue: '',
				checkedKeys: []
			});

			const arrayMenu: TreeNode[] = getLeafNodes(treeData);

			state.loading = false;
			state.categories = data;
			state.categoriesMenu = arrayMenu;
		},

		getEbcCategoriesById: (state) => {
			state.loadingCategoriesById = true;
		},
		getEbcCategoriesByIdError: (state) => {
			state.loadingCategoriesById = false;
		},
		getEbcCategoriesByIdSuccess: (state, action) => {
			state.loadingCategoriesById = false;
			state.categoriesById = action.payload;
		},
	},
});

export const {
	updateExpandedKeys,
	updateSelectedKeys,

	changeNameDescription,
	changeToggleFilter,

	updatePricesAll,

	clearAllCheckbox,
	changeCheckboxAll,

	changeGoTo,
	changeSize,
	changePage,

	changeCurrentPriceType,
	changePriceItem,
	changeQuantity,
	changeCheckboxItem,

	changeTypeViewList,
	categoryDescription,

	getCategories,
	getCategoriesError,
	getCategoriesSuccess,

	getEbcCategoriesById,
	getEbcCategoriesByIdError,
	getEbcCategoriesByIdSuccess,
} = pfizerSlice.actions;

export default pfizerSlice.reducer;
